/* eslint-disable */
import { FC, useEffect, useState } from "react";
import PropTypes from "prop-types";
import * as Yup from "yup";
import {
  Button,
  Grid,
  Typography,
  TextField,
  Box,
  Card,
  CardContent,
  CircularProgress,
  FormHelperText,
  Dialog,
  IconButton,
} from "@material-ui/core";
import { useStyles } from "../style";
import useAuth from "src/hooks/useAuth";
import { Formik } from "formik";
import XIcon from "src/icons/X";
import { useSnackbar } from "notistack";
import priorTool from "../../assets/img/priorTool.svg";
import priorBalance from "../../assets/img/priorBalance.svg";
import accessRelease from "../../assets/img/access-release.svg";
import extraction from "../../assets/img/extraction.svg";
import accessSendedRelease from "../../assets/img/access-sended.svg";
import step1 from "../../assets/img/step1.svg";
import step2 from "../../assets/img/step2.svg";
import step3 from "../../assets/img/step3.svg";
import step2Gray from "../../assets/img/step2-grey.svg";
import step3Gray from "../../assets/img/step3-grey.svg";
import success from "../../assets/img/success.svg";
import { sendErp, updateFirstStep } from "../bridges/BrigdeUser";
import useIndicators from "src/hooks/useIndicators";
import {useNavigate} from "react-router-dom";

interface IModalContractProps {}

const ModalPreUsed: FC<IModalContractProps> = (props) => {
  const { firstStep, getFirstStep } = useIndicators();
  const { user } = useAuth();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  const classes = useStyles();
  const [modalOpen, setModalOpen] = useState(true);
  const phraseList = ['Balance General', 'Estado de Resultados', 'Presupuesto de Efectivo', 'Flujo de Efectivo', 'Indicadores Financieros'];
  const [currentIndex, setCurrentIndex] = useState(0);
  // const [finishButton, setFinishButton] = useState(true);
  const [step, setStep] = useState(user.firstStepContract.email !== null &&
      user.firstStepContract.notes === '' &&
      user.signedContratUrl !== 'N/A' ? 3 : 0);
  let visibleModal = window.localStorage.getItem("firstStep");
  let companyName = user.businessId?.company;
  // console.log(user);

  const handleClose = () => {
    setModalOpen(false);
  };

  const handleLastStep = async () => {
    try {
      let obj = {
        businessId: user["businessId"]["business_id"],
        firstStep: false,
      };
      await updateFirstStep(obj);
      handleClose();
      window.location.reload();
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const intervalId = setInterval(() => {
      // Increment the index, and loop back to 0 if it exceeds the array length
      setCurrentIndex((prevIndex) => (prevIndex + 1) % phraseList.length);
    }, 15000); // 30 seconds

    // Cleanup the interval on component unmount
    return () => clearInterval(intervalId);
  }, []);

  useEffect(() => {
    visibleModal = window.localStorage.getItem("firstStep");
    console.log(visibleModal);
    if (user.firstStep === undefined && user.businessId.isComplete !== null && visibleModal !== "6") {
      navigate('/complete_onboarding');
    } else if (visibleModal === "6") {
      window.localStorage.setItem('firstStep', '7');
      window.location.reload();
    }
  }, []);

  useEffect(() => {
    visibleModal = window.localStorage.getItem("firstStep");
    if (visibleModal === "1" || visibleModal === "4") {
      getFirstStep(false);
    }

    if (visibleModal === "2" || visibleModal === "3" || visibleModal === "5") {
      getFirstStep(true);
    }
  }, [firstStep]);

  return (
    /* prettier-ignore */
    <>
    {user.firstStepContract !== null && 
              user.firstStepContract !== undefined &&
            <>
      {firstStep === null ||
        firstStep === true ? (
          <Dialog open={modalOpen} fullWidth maxWidth={'md'} scroll="paper">
            <Box display="flex" justifyContent="flex-end">
              <IconButton onClick={handleClose}>
                <XIcon fontSize="small" />
              </IconButton>
            </Box>
              {user.firstStepContract.email === null &&
                  user.firstStepContract.notes === '' &&
                  user.signedContratUrl === 'N/A' && (
                  <Box sx={{ margin: 3 }}>
                    <Grid container px={5} py={2}>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        display="flex"
                        justifyContent="center"
                      >
                        <Box
                          alt="Prior Tool"
                          component="img"
                          src={priorTool}
                          sx={{ width: '30%' }}
                        />
                      </Grid>
                      <Grid
                          item
                          xs={12}
                          md={12}
                          display="flex"
                          justifyContent="center"
                          pt={4}
                          pb={1}
                      >
                        <Typography
                            color="#024787"
                            fontWeight={900}
                            fontSize="32px"
                        >
                          ¡Bienvenido {companyName}!
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        display="flex"
                        justifyContent="center"
                        pt={1}
                        pb={1}
                      >
                        <Typography
                          color="#405364"
                          fontWeight={900}
                          fontSize="24px"
                          textAlign="center"
                        >
                          Olvídate de gastar tiempo cuadrando los estados financieros
                          <br/> a cada minuto.
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        display="flex"
                        justifyContent="center"
                        pt={1}
                        pb={4}
                      >
                        <Typography
                          color="#405364"
                          fontWeight={400}
                          fontSize="18px"
                          textAlign="center"
                        >
                          Completa los siguientes pasos para configurar la planificación financiera <br/> de tu empresa.
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        display="flex"
                        justifyContent="flex-start"
                        py={2}
                        px={10}
                      >
                        <Box
                          alt="Prior Tool"
                          component="img"
                          src={step1}
                          sx={{ width: '5%' }}
                        />
                        <Typography
                          color="#5d6b83"
                          fontWeight={400}
                          fontSize="20px"
                          pl={2}
                        >
                          Revisa el contrato de{' '}
                          <span style={{ color: '#FCBE00', fontWeight: 600 }}>
                            <a
                              style={{ color: '#FCBE00', fontWeight: 600 }}
                              href="/dashboard/contract"
                              onClick={() => {
                                window.localStorage.setItem('firstStep', '1');
                                getFirstStep(false);
                              }}
                            >
                              Prestación de Servicios en Línea
                            </a>
                          </span>
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        display="flex"
                        justifyContent="flex-start"
                        py={2}
                        px={10}
                      >
                        <Box
                          alt="Prior Tool"
                          component="img"
                          src={step2Gray}
                          sx={{ width: '4%' }}
                        />
                        <Typography
                          color="#5d6b83"
                          fontWeight={400}
                          fontSize="20px"
                          pl={2}
                        >
                          <span style={{ color: 'gray', fontWeight: 600 }}>
                            Brinda accesos
                          </span>{' '}
                          para conectarnos al ERP de tu empresa
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        display="flex"
                        justifyContent="flex-start"
                        py={2}
                        px={10}
                      >
                        <Box
                          alt="Prior Tool"
                          component="img"
                          src={step3Gray}
                          sx={{ width: '4%' }}
                        />
                        <Typography
                          color="#5d6b83"
                          fontWeight={400}
                          fontSize="20px"
                          pl={2}
                        >
                          <span style={{ color: 'gray', fontWeight: 600 }}>
                            Ingresa los datos financieros
                          </span>{' '}
                          de tu empresa
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        display="flex"
                        justifyContent="center"
                        pt={5}
                      >
                        <Button
                          sx={{
                            backgroundColor: '#FCBE00',
                            borderRadius: '64px',
                          }}
                          variant="contained"
                          onClick={handleClose}
                        >
                          COMPLETAR PASOS LUEGO
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                )}
              {user.firstStepContract.email === null &&
                user.firstStepContract.notes === '' &&
                user.signedContratUrl !== 'N/A' && (
                  <>
                    {step === 0 && (
                      <Box sx={{ margin: 5 }}>
                        <Grid container px={5} py={2}>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                          >
                            <Box
                              alt="Prior Tool"
                              component="img"
                              src={priorTool}
                              sx={{ width: '30%' }}
                            />
                          </Grid>
                          <Grid
                              item
                              xs={12}
                              md={12}
                              display="flex"
                              justifyContent="center"
                              pt={4}
                              pb={1}
                          >
                            <Typography
                                color="#024787"
                                fontWeight={900}
                                fontSize="32px"
                            >
                              ¡Bienvenido {companyName}!
                            </Typography>
                          </Grid>
                          <Grid
                              item
                              xs={12}
                              md={12}
                              display="flex"
                              justifyContent="center"
                              pt={1}
                              pb={1}
                          >
                            <Typography
                                color="#405364"
                                fontWeight={900}
                                fontSize="24px"
                                textAlign="center"
                            >
                              Olvídate de gastar tiempo cuadrando los estados financieros
                              <br/> a cada minuto.
                            </Typography>
                          </Grid>
                          <Grid
                              item
                              xs={12}
                              md={12}
                              display="flex"
                              justifyContent="center"
                              pt={1}
                              pb={4}
                          >
                            <Typography
                                color="#405364"
                                fontWeight={400}
                                fontSize="18px"
                                textAlign="center"
                            >
                              Completa los siguientes pasos para configurar la planificación financiera <br/> de tu empresa.
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="flex-start"
                            py={2}
                            px={10}
                          >
                            <Box
                              alt="Prior Tool"
                              component="img"
                              src={success}
                              sx={{ width: '5%' }}
                            />
                            <Typography
                              color="#5d6b83"
                              fontWeight={400}
                              fontSize="20px"
                              pl={2}
                            >
                              Revisa el contrato de{' '}
                              <span
                                style={{ color: '#FCBE00', fontWeight: 600 }}
                              >
                                <a
                                  style={{
                                    color: '#FCBE00',
                                    fontWeight: 600,
                                  }}
                                >
                                  Prestación de Servicios en Línea
                                </a>
                              </span>
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="flex-start"
                            py={2}
                            px={10}
                          >
                            <Box
                              alt="Prior Tool"
                              component="img"
                              src={step2}
                              sx={{ width: '5%' }}
                            />
                            <Typography
                              color="#5d6b83"
                              fontWeight={400}
                              fontSize="20px"
                              pl={2}
                            >
                              <span
                                style={{ color: '#FCBE00', fontWeight: 600 }}
                              >
                                <a
                                  style={{ color: '#FCBE00', fontWeight: 600 }}
                                  href="#"
                                  onClick={() => {
                                    setStep(1);
                                  }}
                                >
                                  Brinda accesos
                                </a>
                              </span>{' '}
                              para conectarnos al ERP de tu empresa
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="flex-start"
                            py={2}
                            px={10}
                          >
                            <Box
                              alt="Prior Tool"
                              component="img"
                              src={step3Gray}
                              sx={{ width: '4%' }}
                            />
                            <Typography
                                color="#5d6b83"
                                fontWeight={400}
                                fontSize="20px"
                                pl={2}
                            >
                              <span style={{ color: 'gray', fontWeight: 600 }}>
                                Ingresa los datos financieros
                              </span>{' '}
                                de tu empresa
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                            pt={5}
                          >
                            <Button
                              sx={{
                                backgroundColor: '#FCBE00',
                                borderRadius: '64px',
                              }}
                              variant="contained"
                              onClick={handleClose}
                            >
                              COMPLETAR PASOS LUEGO
                            </Button>
                          </Grid>
                        </Grid>
                      </Box>
                    )}
                    {step === 1 && (
                      <Box sx={{ margin: 5 }}>
                        <Grid container px={5} py={2}>
                          {/* <Grid item xs={12} display="flex" justifyContent="center"> */}
                          <Formik
                            initialValues={{
                              name: '',
                              email: '',
                              apiKey: '',
                              submit: null,
                            }}
                            validationSchema={Yup.object().shape({
                              name: Yup.string()
                                  .matches(
                                      /^[a-zA-ZñÑáéíóúÁÉÍÓÚ]+(\s+[a-zA-ZñÑáéíóúÁÉÍÓÚ]+)*$/,
                                      'Ingresa únicamente letras del abecedario'
                                  )
                                  .required('Nombre es requerido'),
                              email: Yup.string()
                                .email('Debe ser un correo válido')
                                .max(255)
                                .required('Email es requerido'),
                              apiKey: Yup.string()
                                  .required('Api de accesso requerido'),
                            })}
                            onSubmit={async (
                              values,
                              { setErrors, setStatus, setSubmitting }
                            ) => {
                              try {
                                values['businessId'] =
                                  user['businessId']['business_id'];
                                await sendErp(values);
                                setSubmitting(false);
                                window.localStorage.setItem('firstStep', '3');
                                setStep(2);
                                // nextStep();
                              } catch (err) {
                                console.error(err);
                                setStatus({ success: false });
                                setErrors({ submit: err.message });
                                setSubmitting(false);
                              }
                            }}
                          >
                            {({
                              errors,
                              handleBlur,
                              handleChange,
                              handleSubmit,
                              setFieldValue,
                              setFieldTouched,
                              isSubmitting,
                              touched,
                              values,
                            }) => (
                              <Box>
                                {isSubmitting ? (
                                  <Box
                                    display="flex"
                                    justifyContent="center"
                                    my={5}
                                  >
                                    <CircularProgress />
                                  </Box>
                                ) : (
                                  <form onSubmit={handleSubmit}>
                                    <Grid
                                      item
                                      xs={12}
                                      md={12}
                                      display="flex"
                                      justifyContent="center"
                                    >
                                      <Box
                                        alt="Prior Tool"
                                        component="img"
                                        src={accessRelease}
                                        sx={{ width: '30%' }}
                                      />
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      md={12}
                                      display="flex"
                                      justifyContent="center"
                                      pt={4}
                                      pb={1}
                                    >
                                      <Typography
                                        color="#405364"
                                        fontWeight={900}
                                        fontSize="24px"
                                      >
                                        Brinda acceso para conectarnos al ERP
                                        de tu empresa
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      md={12}
                                      display="flex"
                                      justifyContent="center"
                                      py={3}
                                      px={10}
                                    >
                                      <Typography
                                        color="#405364"
                                        fontWeight={400}
                                        fontSize="18px"
                                      >
                                        Favor ingresa los datos del encargado de
                                        TI para indicarle el procedimiento y los
                                        accesos que necesitamos para conectar
                                        Prior<sup>&reg;</sup>  a tu empresa.
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      display="flex"
                                      justifyContent="center"
                                    >
                                      <TextField
                                        error={Boolean(
                                          touched.name && errors.name
                                        )}
                                        sx={{ width: '75%' }}
                                        helperText={
                                          touched.name && errors.name
                                        }
                                        label="Nombre del encargado de TI"
                                        name="name"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.name}
                                        variant="outlined"
                                        autoComplete="off"
                                      />
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      display="flex"
                                      justifyContent="center"
                                      my={3}
                                    >
                                      <TextField
                                        error={Boolean(
                                          touched.email && errors.email
                                        )}
                                        sx={{ width: '75%' }}
                                        helperText={
                                          touched.email && errors.email
                                        }
                                        label="Correo electrónico"
                                        name="email"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.email}
                                        variant="outlined"
                                        autoComplete="off"
                                      />
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      display="flex"
                                      justifyContent="center"
                                    >
                                      <TextField
                                        error={Boolean(
                                          touched.apiKey && errors.apiKey
                                        )}
                                        sx={{ width: '75%' }}
                                        helperText={
                                          touched.apiKey && errors.apiKey
                                        }
                                        label="API de acceso"
                                        name="apiKey"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        value={values.apiKey}
                                        variant="outlined"
                                        autoComplete="off"
                                      />
                                    </Grid>
                                    {Boolean(errors.submit) && (
                                      <FormHelperText error>
                                        {errors.submit}
                                      </FormHelperText>
                                    )}
                                    <Box mt={2}>
                                      <Box
                                        display="flex"
                                        justifyContent="center"
                                        my={5}
                                      >
                                        <Button
                                          sx={{
                                            backgroundColor: '#FCBE00',
                                            borderRadius: '64px',
                                            width: '240px',
                                          }}
                                          variant="contained"
                                          size="large"
                                          type="submit"
                                        >
                                          ENVIAR
                                        </Button>
                                      </Box>
                                    </Box>
                                  </form>
                                )}
                              </Box>
                            )}
                          </Formik>
                          {/* </Grid> */}
                        </Grid>
                      </Box>
                    )}
                    {step === 2 && (
                      <Box sx={{ margin: 5 }}>
                        <Grid container p={5}>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                          >
                            <Box
                              alt="Prior Tool"
                              component="img"
                              src={accessSendedRelease}
                              sx={{ width: '30%' }}
                            />
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                            pt={4}
                            pb={1}
                          >
                            <Typography
                              color="#405364"
                              fontWeight={900}
                              fontSize="24px"
                            >
                              ¡Correo enviado con éxito!
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                            py={3}
                            px={10}
                          >
                            <Typography
                              color="#405364"
                              fontWeight={400}
                              fontSize="18px"
                              textAlign="center"
                            >
                              Una vez que el encargado de TI nos brinde los
                              accesos,{' '}
                              <span style={{ fontWeight: 600 }}>
                                Prior<sup>&reg;</sup> se conectará al ERP en menos de 24 horas.
                              </span>
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                            px={10}
                          >
                            <Typography
                              color="#405364"
                              fontWeight={400}
                              fontSize="18px"
                              textAlign="center"
                            >
                              Te avisaremos cuando se haya completado este paso
                              para que continúes con el proceso.
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                            py={5}
                          >
                            <Button
                              sx={{
                                backgroundColor: '#FCBE00',
                                borderRadius: '64px',
                                width: '240px',
                              }}
                              onClick={() => {
                                setStep(0);
                                window.location.reload();
                              }}
                              variant="contained"
                              size="large"
                            >
                              CERRAR
                            </Button>
                          </Grid>
                          <Grid item xs={12}>
                            <Typography
                              textAlign="center"
                              color="#5d6b83"
                              fontSize="14px"
                              fontWeight={400}
                            >
                              ¿No recibió el correo?{' '}
                              <span
                                style={{
                                  textDecoration: 'underline',
                                  color: '#FCBE00',
                                }}
                              >
                                <a
                                  style={{
                                    color: '#FCBE00',
                                    fontWeight: 'bold',
                                  }}
                                  onClick={() => setStep(1)}
                                  href="#"
                                >
                                  Vuelve a enviarlo
                                </a>
                              </span>
                            </Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    )}
                  </>
                )}
              {user.firstStepContract.email !== null &&
                user.firstStepContract.notes === '' &&
                user.signedContratUrl !== 'N/A'  && (
                  <>
                    {step === 0 && (
                      <Box sx={{ margin: 5 }}>
                        <Grid container px={5} py={2}>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                          >
                            <Box
                              alt="Prior Tool"
                              component="img"
                              src={priorTool}
                              sx={{ width: '30%' }}
                            />
                          </Grid>
                          <Grid
                              item
                              xs={12}
                              md={12}
                              display="flex"
                              justifyContent="center"
                              pt={4}
                              pb={1}
                          >
                            <Typography
                                color="#024787"
                                fontWeight={900}
                                fontSize="32px"
                            >
                              ¡Bienvenido {companyName}!
                            </Typography>
                          </Grid>
                          <Grid
                              item
                              xs={12}
                              md={12}
                              display="flex"
                              justifyContent="center"
                              pt={1}
                              pb={1}
                          >
                            <Typography
                                color="#405364"
                                fontWeight={900}
                                fontSize="24px"
                                textAlign="center"
                            >
                              Olvídate de gastar tiempo cuadrando los estados financieros
                              <br/> a cada minuto.
                            </Typography>
                          </Grid>
                          <Grid
                              item
                              xs={12}
                              md={12}
                              display="flex"
                              justifyContent="center"
                              pt={1}
                              pb={4}
                          >
                            <Typography
                                color="#405364"
                                fontWeight={400}
                                fontSize="18px"
                                textAlign="center"
                            >
                              Completa los siguientes pasos para configurar la planificación financiera <br/> de tu empresa.
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="flex-start"
                            py={2}
                            px={10}
                          >
                            <Box
                              alt="Prior Tool"
                              component="img"
                              src={success}
                              sx={{ width: '5%' }}
                            />
                            <Typography
                              color="#5d6b83"
                              fontWeight={400}
                              fontSize="20px"
                              pl={2}
                            >
                              Revisa el contrato de{' '}
                              <span
                                style={{ color: '#FCBE00', fontWeight: 600 }}
                              >
                                <a
                                  style={{
                                    color: '#FCBE00',
                                    fontWeight: 600,
                                  }}
                                >
                                  Prestación de Servicios en Línea
                                </a>
                              </span>
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="flex-start"
                            py={2}
                            px={10}
                          >
                            <Box
                              alt="Prior Tool"
                              component="img"
                              src={step2}
                              sx={{ width: '5%' }}
                            />
                            <Typography
                              color="#5d6b83"
                              fontWeight={400}
                              fontSize="20px"
                              pl={2}
                            >
                              <span
                                style={{ color: '#FCBE00', fontWeight: 600 }}
                              >
                                <a
                                  style={{ color: '#FCBE00', fontWeight: 600 }}
                                  href="#"
                                  onClick={() => {
                                    setStep(1);
                                  }}
                                >
                                  Brinda accesos
                                </a>
                              </span>{' '}
                              para conectarnos al ERP de tu empresa
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="flex-start"
                            py={2}
                            px={10}
                          >
                            <Box
                              alt="Prior Tool"
                              component="img"
                              src={step3Gray}
                              sx={{ width: '4%' }}
                            />
                            <Typography
                                color="#5d6b83"
                                fontWeight={400}
                                fontSize="20px"
                                pl={2}
                            >
                              <span style={{ color: 'gray', fontWeight: 600 }}>
                                Ingresa los datos financieros
                              </span>{' '}
                                de tu empresa
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                            pt={5}
                          >
                            <Button
                              sx={{
                                backgroundColor: '#FCBE00',
                                borderRadius: '64px',
                              }}
                              variant="contained"
                              onClick={handleClose}
                            >
                              COMPLETAR PASOS LUEGO
                            </Button>
                          </Grid>
                        </Grid>
                      </Box>
                    )}
                    {step === 1 && (
                      <Box sx={{ margin: 5 }}>
                        <Grid container p={5}>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                          >
                            <Box
                              alt="Prior Tool"
                              component="img"
                              src={accessSendedRelease}
                              sx={{ width: '30%' }}
                            />
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                            pt={4}
                            pb={1}
                          >
                            <Typography
                              color="#405364"
                              fontWeight={900}
                              fontSize="24px"
                            >
                              ¡Correo enviado con éxito!
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                            py={3}
                            px={10}
                          >
                            <Typography
                              color="#405364"
                              fontWeight={400}
                              fontSize="18px"
                              textAlign="center"
                            >
                              Una vez que el encargado de TI nos brinde los
                              accesos,{' '}
                              <span style={{ fontWeight: 600 }}>
                                Prior<sup>&reg;</sup> se conectará al ERP en menos de 24 horas.
                              </span>
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                            px={10}
                          >
                            <Typography
                              color="#405364"
                              fontWeight={400}
                              fontSize="18px"
                              textAlign="center"
                            >
                              Te avisaremos cuando se haya completado este paso para que continúes con el proceso.
                            </Typography>
                          </Grid>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            display="flex"
                            justifyContent="center"
                            py={5}
                          >
                            <Button
                              sx={{
                                backgroundColor: '#FCBE00',
                                borderRadius: '64px',
                                width: '240px',
                              }}
                              onClick={handleClose}
                              variant="contained"
                              size="large"
                            >
                              CERRAR
                            </Button>
                          </Grid>
                          <Grid item xs={12}>
                            <Typography
                              textAlign="center"
                              color="#5d6b83"
                              fontSize="14px"
                              fontWeight={400}
                            >
                              ¿No recibió el correo?{' '}
                              <span
                                style={{
                                  textDecoration: 'underline',
                                  color: '#FCBE00',
                                }}
                              >
                                <a
                                  style={{
                                    color: '#FCBE00',
                                    fontWeight: 'bold',
                                  }}
                                  href="#"
                                  onClick={() => {
                                    setStep(2);
                                  }}
                                >
                                  Vuelve a enviarlo
                                </a>
                              </span>
                            </Typography>
                          </Grid>
                        </Grid>
                      </Box>
                    )}
                    {step === 2 && (
                      <Box sx={{ margin: 5 }}>
                        <Grid container p={5}>
                          {/* <Grid item xs={12} display="flex" justifyContent="center"> */}
                          <Formik
                            initialValues={{
                              name: '',
                              email: '',
                              apiKey: '',
                              submit: null,
                            }}
                            validationSchema={Yup.object().shape({
                              name: Yup.string()
                                  .matches(
                                      /^[a-zA-ZñÑáéíóúÁÉÍÓÚ]+(\s+[a-zA-ZñÑáéíóúÁÉÍÓÚ]+)*$/,
                                      'Ingresa únicamente letras del abecedario'
                                  )
                                  .required('Nombre es requerido'),
                              email: Yup.string()
                                  .email('Debe ser un correo válido')
                                  .max(255)
                                  .required('Email es requerido'),
                              apiKey: Yup.string()
                                  .required('Api de accesso requerido'),
                            })}
                            onSubmit={async (
                              values,
                              { setErrors, setStatus, setSubmitting }
                            ) => {
                              try {
                                values['businessId'] =
                                  user['businessId']['business_id'];
                                await sendErp(values);
                                setSubmitting(false);
                                window.localStorage.setItem('firstStep', '3');
                                setStep(1);
                              } catch (err) {
                                console.error(err);
                                setStatus({ success: false });
                                setErrors({ submit: err.message });
                                setSubmitting(false);
                              }
                            }}
                          >
                            {({
                              errors,
                              handleBlur,
                              handleChange,
                              handleSubmit,
                              setFieldValue,
                              setFieldTouched,
                              isSubmitting,
                              touched,
                              values,
                            }) => (
                              <Box>
                                {isSubmitting ? (
                                  <Box
                                    display="flex"
                                    justifyContent="center"
                                    my={5}
                                  >
                                    <CircularProgress />
                                  </Box>
                                ) : (
                                  <form onSubmit={handleSubmit}>
                                    <Grid
                                      item
                                      xs={12}
                                      md={12}
                                      display="flex"
                                      justifyContent="center"
                                    >
                                      <Box
                                        alt="Prior Tool"
                                        component="img"
                                        src={accessRelease}
                                        sx={{ width: '30%' }}
                                      />
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      md={12}
                                      display="flex"
                                      justifyContent="center"
                                      pt={4}
                                      pb={1}
                                    >
                                      <Typography
                                        color="#405364"
                                        fontWeight={900}
                                        fontSize="24px"
                                      >
                                        Brinda accesos para conectarnos al ERP
                                        de tu empresa
                                      </Typography>
                                    </Grid>
                                    <Grid
                                      item
                                      xs={12}
                                      md={12}
                                      display="flex"
                                      justifyContent="center"
                                      py={3}
                                      px={10}
                                    >
                                      <Typography
                                        color="#405364"
                                        fontWeight={400}
                                        fontSize="18px"
                                      >
                                        Favor ingresa los datos del encargado de TI
                                        para indicarle el procedimiento y los accesos
                                        que necesitamos para conectar Prior <sup>&reg;</sup> a tu empresa.
                                      </Typography>
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        display="flex"
                                        justifyContent="center"
                                    >
                                      <TextField
                                          error={Boolean(
                                              touched.name && errors.name
                                          )}
                                          sx={{ width: '75%' }}
                                          helperText={
                                              touched.name && errors.name
                                          }
                                          label="Nombre del encargado de TI"
                                          name="name"
                                          onBlur={handleBlur}
                                          onChange={handleChange}
                                          value={values.name}
                                          variant="outlined"
                                          autoComplete="off"
                                      />
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        display="flex"
                                        justifyContent="center"
                                        my={3}
                                    >
                                      <TextField
                                          error={Boolean(
                                              touched.email && errors.email
                                          )}
                                          sx={{ width: '75%' }}
                                          helperText={
                                              touched.email && errors.email
                                          }
                                          label="Correo electrónico"
                                          name="email"
                                          onBlur={handleBlur}
                                          onChange={handleChange}
                                          value={values.email}
                                          variant="outlined"
                                          autoComplete="off"
                                      />
                                    </Grid>
                                    <Grid
                                        item
                                        xs={12}
                                        display="flex"
                                        justifyContent="center"
                                    >
                                      <TextField
                                          error={Boolean(
                                              touched.apiKey && errors.apiKey
                                          )}
                                          sx={{ width: '75%' }}
                                          helperText={
                                              touched.apiKey && errors.apiKey
                                          }
                                          label="API de acceso"
                                          name="apiKey"
                                          onBlur={handleBlur}
                                          onChange={handleChange}
                                          value={values.apiKey}
                                          variant="outlined"
                                          autoComplete="off"
                                      />
                                    </Grid>
                                    {Boolean(errors.submit) && (
                                      <FormHelperText error>
                                        {errors.submit}
                                      </FormHelperText>
                                    )}
                                    <Box mt={2}>
                                      <Box
                                        display="flex"
                                        justifyContent="center"
                                        my={5}
                                      >
                                        <Button
                                          sx={{
                                            backgroundColor: '#FCBE00',
                                            borderRadius: '64px',
                                            width: '240px',
                                          }}
                                          variant="contained"
                                          size="large"
                                          type="submit"
                                        >
                                          ENVIAR
                                        </Button>
                                      </Box>
                                    </Box>
                                  </form>
                                )}
                              </Box>
                            )}
                          </Formik>
                          {/* </Grid> */}
                        </Grid>
                      </Box>
                    )}
                    {step === 3 && (
                       <Box sx={{ margin: 5 }}>
                          <Grid container px={5}>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                display="flex"
                                justifyContent="center"
                            >
                              <Box
                                  alt="Prior Tool"
                                  component="img"
                                  src={extraction}
                                  sx={{ width: '30%' }}
                              />
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                display="flex"
                                justifyContent="center"
                                pt={4}
                                pb={1}
                            >
                              <Typography
                                  color="#405364"
                                  fontWeight={900}
                                  fontSize="24px"
                              >
                                Extrayendo datos del ERP...
                              </Typography>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                display="flex"
                                justifyContent="center"
                                py={3}
                                px={10}
                            >
                              <Typography
                                  color="#405364"
                                  fontWeight={400}
                                  fontSize="18px"
                                  textAlign="center"
                              >
                              <span style={{ fontWeight: 600 }}>
                                Prior<sup>&reg;</sup> logró conectarse al ERP de tu empresa
                                y está extrayendo los datos que necesita para operar.
                              </span>
                              </Typography>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                display="flex"
                                justifyContent="center"
                                px={10}
                            >
                              <Typography
                                  color="#405364"
                                  fontWeight={400}
                                  fontSize="18px"
                                  textAlign="center"
                              >
                                Cuando haya concluido este paso, te escribiremos a <b><u>{user.email}</u></b>{' '}
                                para que continúes con el proceso.
                              </Typography>
                            </Grid>
                            <Grid item xs={12}>
                              <Typography
                                  textAlign="center"
                                  color="#5d6b83"
                                  fontSize="14px"
                                  fontWeight={400}
                              >
                                ¿No recibió el correo?{' '}
                                <span
                                    style={{
                                      textDecoration: 'underline',
                                      color: '#FCBE00',
                                    }}
                                >
                                <a
                                    style={{
                                      color: '#FCBE00',
                                      fontWeight: 'bold',
                                    }}
                                    href="#"
                                    onClick={() => {
                                      setStep(2);
                                    }}
                                >
                                  Vuelve a enviarlo
                                </a>
                              </span>
                              </Typography>
                            </Grid>
                            <Grid
                                item
                                xs={12}
                                md={12}
                                display="flex"
                                justifyContent="center"
                                py={5}
                            >
                              <Button
                                  sx={{
                                    backgroundColor: '#FCBE00',
                                    borderRadius: '64px',
                                    width: '240px',
                                  }}
                                  onClick={handleClose}
                                  variant="contained"
                                  size="large"
                              >
                                CERRAR
                              </Button>
                            </Grid>
                          </Grid>
                        </Box>
                    )}
                  </>
                )}
              {user.firstStepContract.email !== null &&
                user.firstStepContract.notes !== '' &&
                user.signedContratUrl !== 'N/A' &&
                  user.businessId.payment_dates === null &&
                  user.businessId.credit_cards === null && (
                  <Box sx={{ margin: 5 }}>
                    <Grid container px={5} py={2}>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        display="flex"
                        justifyContent="center"
                      >
                        <Box
                          alt="Prior Tool"
                          component="img"
                          src={priorTool}
                          sx={{ width: '30%' }}
                        />
                      </Grid>
                      <Grid
                          item
                          xs={12}
                          md={12}
                          display="flex"
                          justifyContent="center"
                          pt={4}
                          pb={1}
                      >
                        <Typography
                            color="#024787"
                            fontWeight={900}
                            fontSize="32px"
                        >
                          ¡Bienvenido {companyName}!
                        </Typography>
                      </Grid>
                      <Grid
                          item
                          xs={12}
                          md={12}
                          display="flex"
                          justifyContent="center"
                          pt={1}
                          pb={1}
                      >
                        <Typography
                            color="#405364"
                            fontWeight={900}
                            fontSize="24px"
                            textAlign="center"
                        >
                          Olvídate de gastar tiempo cuadrando los estados financieros
                          <br/> a cada minuto.
                        </Typography>
                      </Grid>
                      <Grid
                          item
                          xs={12}
                          md={12}
                          display="flex"
                          justifyContent="center"
                          pt={1}
                          pb={4}
                      >
                        <Typography
                            color="#405364"
                            fontWeight={400}
                            fontSize="18px"
                            textAlign="center"
                        >
                          Completa los siguientes pasos para configurar la planificación financiera <br/> de tu empresa.
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        display="flex"
                        justifyContent="flex-start"
                        py={2}
                        px={10}
                      >
                        <Box
                          alt="Prior Tool"
                          component="img"
                          src={success}
                          sx={{ width: '5%' }}
                        />
                        <Typography
                          color="#5d6b83"
                          fontWeight={400}
                          fontSize="20px"
                          pl={2}
                        >
                          Revisa el contrato de{' '}
                          <span style={{ color: '#FCBE00', fontWeight: 600 }}>
                            <a
                              style={{
                                color: '#FCBE00',
                                fontWeight: 600,
                              }}
                            >
                              Prestación de Servicios en Línea
                            </a>
                          </span>
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        display="flex"
                        justifyContent="flex-start"
                        py={2}
                        px={10}
                      >
                        <Box
                          alt="Prior Tool"
                          component="img"
                          src={success}
                          sx={{ width: '5%' }}
                        />
                        <Typography
                          color="#5d6b83"
                          fontWeight={400}
                          fontSize="20px"
                          pl={2}
                        >
                          <span style={{ color: '#FCBE00', fontWeight: 600 }}>
                            <a style={{ color: '#FCBE00', fontWeight: 600 }}>
                              Brinda accesos
                            </a>
                          </span>{' '}
                          para conectarnos al ERP de tu empresa
                        </Typography>
                      </Grid>
                      <Grid
                          item
                          xs={12}
                          md={12}
                          display="flex"
                          justifyContent="flex-start"
                          py={2}
                          px={10}
                      >
                        <Box
                            alt="Prior Tool"
                            component="img"
                            src={step3}
                            sx={{ width: '5%' }}
                        />
                        <Typography
                            color="#5d6b83"
                            fontWeight={400}
                            fontSize="20px"
                            pl={2}
                        >
                              <span
                                  style={{ color: '#FCBE00', fontWeight: 600 }}
                              >
                                <a
                                    style={{ color: '#FCBE00', fontWeight: 600 }}
                                    href="/dashboard/accounting"
                                    onClick={() => {
                                      window.localStorage.setItem('firstStep', '4');
                                    }}
                                >
                                  Ingresa los datos financieros
                                </a>
                              </span>{' '}
                          de tu empresa
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        display="flex"
                        justifyContent="center"
                        pt={5}
                      >
                        <Button
                            sx={{
                              backgroundColor: '#FCBE00',
                              borderRadius: '64px',
                            }}
                            variant="contained"
                            onClick={handleClose}
                        >
                          COMPLETAR PASOS LUEGO
                        </Button>
                      </Grid>
                    </Grid>
                  </Box>
                )}
              {user.firstStepContract.email !== null &&
                user.firstStepContract.notes !== '' &&
                user.signedContratUrl !== 'N/A' &&
                  user.businessId.payment_dates !== null &&
                  user.businessId.credit_cards !== null && (
                  <Box sx={{ margin: 5 }}>
                    <Grid container px={5} py={2}>
                      <Grid
                        item
                        xs={12}
                        md={12}
                        display="flex"
                        justifyContent="center"
                      >
                        <Box
                          alt="Prior Tool"
                          component="img"
                          src={priorBalance}
                          sx={{ width: '30%' }}
                        />
                      </Grid>
                      <Grid
                          item
                          xs={12}
                          md={12}
                          display="flex"
                          justifyContent="center"
                          pt={1}
                          pb={1}
                      >
                        <Typography
                            color="#405364"
                            fontWeight={900}
                            fontSize="24px"
                            textAlign="center"
                        >
                          Proyectando {phraseList[currentIndex]}...
                        </Typography>
                      </Grid>
                      <Grid
                          item
                          xs={12}
                          md={12}
                          display="flex"
                          justifyContent="center"
                          pt={1}
                          pb={4}
                      >
                        <Typography
                            color="#405364"
                            fontWeight={400}
                            fontSize="18px"
                            textAlign="center"
                        >
                         <span style={{fontWeight: "bold"}}>¡Ya tenemos los datos necesarios! Espera un momento mientras realizamos la
                           <br/> proyección financiera de tu empresa.</span> <br/><br/>
                          Cuando haya concluido este paso, te escribiremos a {user.email} para que continúes con el proceso.
                        </Typography>
                      </Grid>
                      {/*<Grid*/}
                      {/*  item*/}
                      {/*  xs={12}*/}
                      {/*  md={12}*/}
                      {/*  display="flex"*/}
                      {/*  justifyContent="flex-start"*/}
                      {/*  py={2}*/}
                      {/*  px={10}*/}
                      {/*>*/}
                      {/*  <Box*/}
                      {/*    alt="Prior Tool"*/}
                      {/*    component="img"*/}
                      {/*    src={success}*/}
                      {/*    sx={{ width: '5%' }}*/}
                      {/*  />*/}
                      {/*  <Typography*/}
                      {/*    color="#5d6b83"*/}
                      {/*    fontWeight={400}*/}
                      {/*    fontSize="20px"*/}
                      {/*    pl={2}*/}
                      {/*  >*/}
                      {/*    Revisa el contrato de{' '}*/}
                      {/*    <span style={{ color: '#FCBE00', fontWeight: 600 }}>*/}
                      {/*      <a*/}
                      {/*        style={{*/}
                      {/*          color: '#FCBE00',*/}
                      {/*          fontWeight: 600,*/}
                      {/*        }}*/}
                      {/*      >*/}
                      {/*        Prestación de Servicios en Línea*/}
                      {/*      </a>*/}
                      {/*    </span>*/}
                      {/*  </Typography>*/}
                      {/*</Grid>*/}
                      {/*<Grid*/}
                      {/*  item*/}
                      {/*  xs={12}*/}
                      {/*  md={12}*/}
                      {/*  display="flex"*/}
                      {/*  justifyContent="flex-start"*/}
                      {/*  py={2}*/}
                      {/*  px={10}*/}
                      {/*>*/}
                      {/*  <Box*/}
                      {/*    alt="Prior Tool"*/}
                      {/*    component="img"*/}
                      {/*    src={success}*/}
                      {/*    sx={{ width: '5%' }}*/}
                      {/*  />*/}
                      {/*  <Typography*/}
                      {/*    color="#5d6b83"*/}
                      {/*    fontWeight={400}*/}
                      {/*    fontSize="20px"*/}
                      {/*    pl={2}*/}
                      {/*  >*/}
                      {/*    <span style={{ color: '#FCBE00', fontWeight: 600 }}>*/}
                      {/*      <a style={{ color: '#FCBE00', fontWeight: 600 }}>*/}
                      {/*        Brinda accesos*/}
                      {/*      </a>*/}
                      {/*    </span>{' '}*/}
                      {/*    para conectarnos al ERP de tu empresa*/}
                      {/*  </Typography>*/}
                      {/*</Grid>*/}
                      {/*<Grid*/}
                      {/*    item*/}
                      {/*    xs={12}*/}
                      {/*    md={12}*/}
                      {/*    display="flex"*/}
                      {/*    justifyContent="flex-start"*/}
                      {/*    py={2}*/}
                      {/*    px={10}*/}
                      {/*>*/}
                      {/*  <Box*/}
                      {/*      alt="Prior Tool"*/}
                      {/*      component="img"*/}
                      {/*      src={success}*/}
                      {/*      sx={{ width: '5%' }}*/}
                      {/*  />*/}
                      {/*  <Typography*/}
                      {/*      color="#5d6b83"*/}
                      {/*      fontWeight={400}*/}
                      {/*      fontSize="20px"*/}
                      {/*      pl={2}*/}
                      {/*  >*/}
                      {/*    <span style={{ color: '#FCBE00', fontWeight: 600 }}>*/}
                      {/*      <a style={{ color: '#FCBE00', fontWeight: 600 }}>*/}
                      {/*        Ingresa los datos financieros*/}
                      {/*      </a>*/}
                      {/*    </span>{' '}*/}
                      {/*    de tu empresa*/}
                      {/*  </Typography>*/}
                      {/*</Grid>*/}
                      <Grid
                        item
                        xs={12}
                        md={12}
                        display="flex"
                        justifyContent="center"
                        pt={2}
                      >
                        <Button
                          sx={{
                            backgroundColor: '#FCBE00',
                            borderRadius: '64px',
                          }}
                          variant="contained"
                          onClick={handleClose}
                        >
                          IR AL DASHBOARD
                        </Button>
                        {/*<Button*/}
                        {/*  sx={{*/}
                        {/*    backgroundColor: '#FCBE00',*/}
                        {/*    borderRadius: '64px',*/}
                        {/*  }}*/}
                        {/*  variant="contained"*/}
                        {/*  onClick={handleLastStep}*/}
                        {/*>*/}
                        {/*  IR AL DASHBOARD*/}
                        {/*</Button>*/}
                      </Grid>
                    </Grid>
                  </Box>
                )}

          </Dialog>
        ):null}</>}
    </>
  );
};

ModalPreUsed.propTypes = {};

export default ModalPreUsed;
